import { AxiosRequestHeaders, RawAxiosRequestHeaders } from 'axios'
import { btoaHex, MapLike } from '../core'
import { TypeScopedValidCoreApplicationType, ValidBusinessObject } from '../datastoreProxy'

export enum Networks {
  ThingPark = 'ThingPark',
  TTN_Community = 'TTN_Community',
  TTN_Enterprise = 'TTN_Enterprise',
  Chirpstack = 'Chirpstack',
  Interceptor = 'Interceptor',
  AWS_LPWAN = 'AWS_LPWAN',
  Helium = 'Helium',
}

export type NetworkKey = keyof typeof Networks

export type AssemblePayloadRequest = {
  device: TypeScopedValidCoreApplicationType<'Device'> & ValidBusinessObject
  RequestId: string
  MessageType: number
  networkKey: NetworkKey
  ApplicationId: string
  /**
   * DeviceId Removed as not known whether to use eui (CS) or deviceId (TTNE) until NAS resolved in DeviceController
   */
  desiredPayload: MapLike<any>
  downlinkAction: DownlinkAction
}

export interface IDownLinkData {}

export type DownlinkRequest<D extends IDownLinkData> = {
  url: string
  method: 'POST'
  headers: any
  data: D
  responseType: 'json'
}

export type DeleteRequest = {
  url: string
  method: 'DELETE'
  headers: any
  responseType: 'json'
}

export type GetRequest = {
  url: string
  method: 'GET'
  headers: any
  responseType: 'json'
}

export enum DownlinkAction {
  PUSH = 'PUSH',
  REPLACE = 'REPLACE',
}

export type IoTVDownlinkParam = {
  ApplicationId: string
  WebHookId?: string
  DeviceId: string
  DeviceEui: string
  hexPayload: string
  downlinkAction: DownlinkAction
}

export type IoTVDeviceIdAndEui = {
  DeviceId: string
  DeviceEui: string
}

export type IoTVCommonNASRequest = {
  DeviceEui: string
  ApplicationId: string
  WebHookId: string | undefined
}

export type ValidMessagePorts = 2 | 99 | 98 | 97

export type LFCExpectedMessagePortsType = {
  DEFAULT_PORT: 2 // Port 0 indicates that the FRMPayload contains MAC commands only
  SYSTEM_PORT: 99 // Used for system payloads
  CONFIG_PORT: 98 // Used for config payloads
  SETTINGS_PORT: 97 // Used for device settings
}

export const LFCExpectedMessagePorts: LFCExpectedMessagePortsType & { [k in keyof LFCExpectedMessagePortsType]: ValidMessagePorts } = {
  DEFAULT_PORT: 2, // Port 0 indicates that the FRMPayload contains MAC commands only
  SYSTEM_PORT: 99, // Used for system payloads
  CONFIG_PORT: 98, // Used for config payloads
  SETTINGS_PORT: 97, // Used for device settings
}
